export const SOLD_VALUE_DEBOUNCE_VALUE = 500

export const DEFAULT_SOLD_VALUES = [200, 2000]

export const MAX_SOLD_QUANTITY_VALUE = 999999999

export const PRODUCT_TYPE_TITLE_COPY = {
  ON_DEMAND: 'on-demand',
  MOQ: 'screen printed',
  DIGITAL: 'digital',
  MANUAL: 'self-fulfilled',
}
